<template>
    <v-container>
            <v-row no-gutters>
            <div class="flex-grow-1">
            <label class="v-label d-block">{{$t('webboxes.styling.text.align')}}</label>
            <v-btn-toggle dense class="pfcl1618818666 d-block mt-1" v-model="textAlignInt">
                <v-btn v-for="o in textAlignOptions" :key="o"><v-icon v-text="`$textAlign${o[0].toUpperCase()}${o.substr(1)}`"></v-icon></v-btn>
            </v-btn-toggle>
            </div>
            <div class="flex-shrink-1">
            <label class="v-label d-block">{{$t('webboxes.styling.text.decoration')}}</label>
            <v-btn-toggle dense multiple class="pfcl1618818667 d-block mt-1" v-model="textDecorationInt">
                <v-btn v-for="o in textDecorationOptions" :key="o"><v-icon v-text="`$text${o[0].toUpperCase()}${o.substr(1)}`"></v-icon></v-btn>
            </v-btn-toggle>
            </div>
            </v-row>
            <label class="v-label d-block mt-5">{{$t('webboxes.styling.text.size.title')}}</label>
        <v-switch class="pfcl1618818698 pr-3" 
                v-model="customSize"
                :label="$t('webboxes.styling.text.size.label')"
            />
        <v-slider 
          v-model="fontSizeInt"
          :disabled="!customSize"
          :thumb-label="true"
          hide-details
          class="pfcl1618818710 align-center pr-3"
          min="0"
          max="50"
        >
                <template v-slot:prepend>
                <v-text-field
                v-model.number="fontSizeInt"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                min="0"
                max="50"
                style="width: 60px"
                suffix="px"
              ></v-text-field>
            </template>
            </v-slider>
    </v-container>
</template>
<script>
export default {
    name: 'TextStyling',
    props: { 'font-size': String, 'text-align': String, 'text-decoration': String, 'font-style': String, 'font-weight': String },
    data() {
        return {
            customSize: !!this.fontSize,
            textAlignOptions: ['left','center','right','justify'],
            textDecorationOptions: ['bold','italic','underline'],
            textDecorationArr: []
        }
    },
    watch: {
        fontSize(val) {
            if(val) {
                this.customSize = true;
            }
        },
        customSize(val) {
            if(!val) {
                this.$emit(`update:font-size`, null);
            }
        }
    },
    computed: {
        textDecorationInt: {
            get() {
                let a = [];
                if(this.fontWeight) {
                    a.push(0);
                }
                if(this.fontStyle) {
                    a.push(1);
                }
                if(this.textDecoration) {
                    a.push(2);
                }
                return a;
            },
            set(val) {
                if(!val) {
                    return;
                }
                
                if(val.includes(0) && !this.fontWeight) {
                    this.$emit(`update:font-weight`, 'bold');
                }
                if(!val.includes(0) && !!this.fontWeight) {
                    this.$emit(`update:font-weight`, null);
                }

                if(val.includes(1) && !this.fontStyle) {
                    this.$emit(`update:font-style`, 'italic');
                }
                if(!val.includes(1) && !!this.fontStyle) {
                    this.$emit(`update:font-style`, null);
                }

                if(val.includes(2) && !this.textDecoration) {
                    this.$emit(`update:text-decoration`, 'underline');
                }
                if(!val.includes(2) && !!this.textDecoration) {
                    this.$emit(`update:text-decoration`, null);
                }
            }
        },
        textAlignInt: {
            get() {
                return this.textAlignOptions.indexOf(this.textAlign);
            },
            set(val) {
                //console.debug(val);
                this.$emit(`update:text-align`, this.textAlignOptions[val]);
            }
        },
        fontSizeInt: {
            get() {
                return this.fontSize ? parseInt(this.fontSize.replace(/\D/g, '')) : null;
            },
            set(val) {
                if(this.customSize) {
                    this.$emit(`update:font-size`, `${val}px`);
                }
            }
        }
        
    },
    methods: {
    }
}
</script>